import { UPDATE_BEWERTUNG } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useUpdateBewertung/mutation';
import { Mitarbeiter_UpdateRotationsplanBewertungMutationVariables } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateBewertung() {
  const [execute, result] = useMutation(UPDATE_BEWERTUNG, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const updateBewertung = useCallback(
    (variables: Mitarbeiter_UpdateRotationsplanBewertungMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [updateBewertung, result] as const;
}
